<template>
  <div class='ui-number'>
    <label v-bind:for='number.instanceGuid' v-text='(number.nickName.length <= 0) ? "Unknown" : number.nickName'></label>
    <div class='item'>
      <input ref='number' type='number' v-bind:value='number.value' v-bind:id='number.isntanceGuid' v-bind:step='step' @input='onChangeNumber' @change='onChangeNumber' />
    </div>
  </div>
</template>

<script>

import UIBase from './UIBase.vue';

export default {
  name: 'UINumber',
  extends: UIBase,
  components: {
  },
  props: {
    number: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
    };
  },
  computed: {
    step: {
      get () {
        if (this.number.numberType <= 0) {
          return 0.1;
        }
        return 1;
      }
    }
  },
  mounted () {
    this.onChange(this.number.value);
  },
  methods: {
    onChangeNumber (e) {
      let v = Number(this.$refs.number.value);
      this.onChange(v);
    },
    onChange (v) {
      this.$refs.number.value = v;
      let n = Number(v);
      if (this.number.value !== n) {
        this.number.change(n);
      }
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/components/UINumber.vue